import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Registro.css';
import classroomImage from '../as.avif'; // Substitua pelo caminho da sua imagem

const Registro = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    nome: '',
    apelido: '',
    escola: '',
    email: '',
    fotografia: null,
    telefone: '',
    dataNascimento: '',
    endereco: '',
    cidade: '',
    estado: '',
    pais: '',
    hobbies: '',
    biografia: '',
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <div className="page-container">
      <div className="image-section">
        <img src={classroomImage} alt="Classroom" />
        <div className="image-text">VAMOS APRENDER JUNTOS</div>
      </div>
      <div className="form-section">
        <h1>Faca Parte da eBB!</h1>
        <div className="tabs">
          <button className="tab" onClick={() => navigate('/Login')}>
            Iniciar Sessao
          </button>
          <button className="tab active" onClick={() => navigate('/Registro')}>
            Registrar
          </button>
        </div>
        <p className="description">
          Com a eBB aprendes em qualquer lugar com as melhores Tecnologias
        </p>
        <form onSubmit={handleSubmit}>
          {step === 1 && (
            <>
              <div className="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  name="nome"
                  placeholder="Enter your Nome"
                  value={formData.nome}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Apelido</label>
                <input
                  type="text"
                  name="apelido"
                  placeholder="Enter your Apelido"
                  value={formData.apelido}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Escola</label>
                <input
                  type="text"
                  name="escola"
                  placeholder="Enter your Escola"
                  value={formData.escola}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your Email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <button type="button" onClick={nextStep} className="next-btn">
                Proximo
              </button>
            </>
          )}

          {step === 2 && (
            <>
              <div className="form-group">
                <label>Fotografia</label>
                <input type="file" name="fotografia" onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Telefone</label>
                <input
                  type="text"
                  name="telefone"
                  placeholder="Enter your Telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Data de Nascimento</label>
                <input
                  type="date"
                  name="dataNascimento"
                  value={formData.dataNascimento}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Endereço</label>
                <input
                  type="text"
                  name="endereco"
                  placeholder="Enter your Endereço"
                  value={formData.endereco}
                  onChange={handleChange}
                />
              </div>
              <div className="step-buttons">
                <button type="button" onClick={prevStep} className="prev-btn">
                  Anterior
                </button>
                <button type="button" onClick={nextStep} className="next-btn">
                  Proximo
                </button>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <div className="form-group">
                <label>Cidade</label>
                <input
                  type="text"
                  name="cidade"
                  placeholder="Enter your Cidade"
                  value={formData.cidade}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Estado</label>
                <input
                  type="text"
                  name="estado"
                  placeholder="Enter your Estado"
                  value={formData.estado}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>País</label>
                <input
                  type="text"
                  name="pais"
                  placeholder="Enter your País"
                  value={formData.pais}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Hobbies</label>
                <input
                  type="text"
                  name="hobbies"
                  placeholder="Enter your Hobbies"
                  value={formData.hobbies}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Biografia</label>
                <textarea
                  name="biografia"
                  placeholder="Enter your Biografia"
                  value={formData.biografia}
                  onChange={handleChange}
                />
              </div>
              <div className="step-buttons">
                <button type="button" onClick={prevStep} className="prev-btn">
                  Anterior
                </button>
                <button type="submit" className="register-btn">
                  Registro
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default Registro;